import React from 'react';
import {
  ICommanderOfflinePanel,
  ILabelValuePanel,
} from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import { LayoutItem } from 'react-grid-layout';
import { useTranslation } from 'react-i18next';
import useCommanderOfflineCount from './useCommanderOfflineCount';
import { CBoxOfflineIcon } from '../../../../../../../../assets/dashboard';
import LabelValuePanel, {
  DefaultRightContainer,
} from '../../../../../../../../theme/ui/Dashboard/LabelValuePanel/LabelValuePanel';

export interface CommanderOfflinePanelProps {
  panel: ICommanderOfflinePanel;
  layout?: LayoutItem | undefined;
}
function CommanderOfflinePanel(props: CommanderOfflinePanelProps) {
  const { panel, layout } = props;
  const { typeRequest } = panel;
  const { t } = useTranslation();
  const { groupId, workspaceId } = panel;
  const {
    isFetching,
    currentData,
    error: errorDevicesConnectionStatus,
  } = useCommanderOfflineCount(panel);

  const labelValuePanel: ILabelValuePanel = {
    type: 'LABEL_VALUE',
    id: `${typeRequest}:${workspaceId}-${groupId}`,
    title: panel.title,
    icon: <CBoxOfflineIcon height={'100%'} />,
    content: (
      <DefaultRightContainer>
        {currentData?.mqttDisconnected}
      </DefaultRightContainer>
    ),
    loading: isFetching,
    error: errorDevicesConnectionStatus
      ? t('dashboard.error.fetching')
      : undefined,
  };
  return <LabelValuePanel panel={labelValuePanel} layout={layout} />;
}

export default CommanderOfflinePanel;
